import { Box, Typography } from '@mui/material';

interface InfoRowProps {
  label: string;
  testId: string;
  children: React.ReactNode;
  multiline?: boolean;
}

export function InfoRow({ label, testId, children, multiline }: InfoRowProps) {
  if (multiline) {
    return (
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {label}
        </Typography>
        <Typography variant="body2" data-testid={testId}>
          {children}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 2,
        mb: 1.5,
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography
        variant="body2"
        data-testid={testId}
        sx={{ textAlign: 'right' }}
      >
        {children}
      </Typography>
    </Box>
  );
}
